import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    salaryRequest: Yup.number()
        .nullable(true)
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen")
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val <= 999999999;
            return true;
        }),
    additionalNotes: checkText(settings),
    motivation: checkText(settings),
});

export const PersonalDataSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formSalaryRequest">
                <Form.Label>Gehaltswunsch pro Jahr</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Jährlichen Gehaltswunsch eingeben"
                    type="text"
                    name="salaryRequest"
                    value={values.salaryRequest || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.salaryRequest && !errors.salaryRequest}
                    isInvalid={touched.salaryRequest && errors.salaryRequest}
                    maxLength={9}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.salaryRequest}
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formEntranceDate">
                <Form.Label>Frühestmöglicher Eintritt</Form.Label>
                <CustomFormControl
                    colors={colors}
                    type="date"
                    name="entranceDate"
                    value={values.entranceDate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.entranceDate && !errors.entranceDate}
                    isInvalid={touched.entranceDate && errors.entranceDate}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.entranceDate}
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formAdditionalNotes">
                <Form.Label>Was wir sonst noch über Sie wissen sollten (Hobbies, Engagement)</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Geben Sie bitte ein, was wir sonst noch über Sie wissen sollten."
                    type="text"
                    name="additionalNotes"
                    value={values.additionalNotes}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.additionalNotes && !errors.additionalNotes}
                    isInvalid={touched.additionalNotes && errors.additionalNotes}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.additionalNotes}
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formMotivation">
                <Form.Label>Warum bewerben Sie sich bei uns?</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Geben Sie bitte ein, warum Sie sich bei uns bewerben."
                    type="text"
                    name="motivation"
                    value={values.motivation}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.motivation && !errors.motivation}
                    isInvalid={touched.motivation && errors.motivation}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.motivation}
                </Form.Control.Feedback>
            </Form.Group>
      </>
    );
};